import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=db07fc18&scoped=true"
import script from "./DropArea.vue?vue&type=script&lang=js"
export * from "./DropArea.vue?vue&type=script&lang=js"
import style0 from "./DropArea.vue?vue&type=style&index=0&id=db07fc18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db07fc18",
  null
  
)

export default component.exports